import {
  faRightFromBracket as freeFasFaRightFromBracket,
  faRightToBracket as freeFasFaRightToBracket,
  faGrip as freeFasFaGrip,
  faSpinner as freeFasFaSpinner,
  faPlus as freeFasFaPlus,
  faPaperPlane as freeFasFaPaperPlane,
  faExclamationTriangle as freeFasFaExclamationTriangle,
  faTimes as freeFasFaTimes,
  faBell as freeFasFaBell,
  faBars as freeFasFaBars,
  faChevronRight as freeFasFaChevronRight,
  faChevronLeft as freeFasFaChevronLeft,
  faClockRotateLeft as freeFasFaClockRotateLeft,
  faComment as freeFasFaComment,
  faChevronDown as freeFasFaChevronDown,
  faMicrophone as freeFasFaMicrophone,
  faCheck as freeFasFaCheck,
  faTrash as freeFasFaTrash,
  faVolumeUp as freeFasFaVolumeUp,
  faVolumeDown as freeFasFaVolumeDown,
  faVolumeMute as freeFasFaVolumeMute,
  faVolumeHigh as freeFasFaVolumeHigh,
  faPlay as freeFasFaPlay,
  faStop as freeFasFaStop,
  faPause as freeFasFaPause,
  faCheckCircle as freeFasFaCheckCircle,
  faBrain as freeFasFaBrain,
  faFileAlt as freeFasFaFileAlt,
  faArrowLeft as freeFasFaArrowLeft,
  faChartLine as freeFasFaChartLine,
  faSave as freeFasFaSave,
  faListCheck as freeFasFaListCheck,
  faBullseye as freeFasFaBullseye,
  faHome as freeFasFaHome,
  faTag as freeFasFaTag,
  faTags as freeFasFaTags,
  faInfoCircle as freeFasFaInfoCircle,
  faEdit as freeFasFaEdit,
  faFileImport as freeFasFaFileImport,
  faRefresh as freeFasFaRefresh,
  faClipboardList as freeFasFaClipboardList,
  faWrench as freeFasFaWrench,
  faCogs as freeFasFaCogs,
  faGear as freeFasFaGear,
  faCircleNotch as freeFasFaCircleNotch,
  faSearch as freeFasFaSearch,
  faBuilding as freeFasFaBuilding,
  faBriefcase as freeFasFaBriefcase,
  faTruck as freeFasFaTruck,
  faCalendarCheck as freeFasFaCalendarCheck,
  faExpand as freeFasFaExpand,
  faClock as freeFasFaClock,
  faCalendar as freeFasFaCalendar,
  faUpload as freeFasFaUpload,
  faDatabase as freeFasFaDatabase,
  faUserEdit as freeFasFaUserEdit,
  faFile as freeFasFaFile,
  faExclamationCircle as freeFasFaExclamationCircle,
  faMinus as freeFasFaMinus,
  faExternalLinkAlt as freeFasFaExternalLinkAlt,
  faRotate as freeFasFaRotate,
  faNewspaper as freeFasFaNewspaper,
  faFolderOpen as freeFasFaFolderOpen,
  faSun as freeFasFaSun,
  faMoon as freeFasFaMoon,
  faBolt as freeFasFaBolt,
  faArrowUp as freeFasFaArrowUp,
  faArrowDown as freeFasFaArrowDown,
  faHeartPulse as freeFasFaHeartPulse,
  faGripVertical as freeFasFaGripVertical,
  faRotateLeft as freeFasFaRotateLeft,
  faThumbsUp as freeFasFaThumbsUp,
  faThumbsDown as freeFasFaThumbsDown,
  faCopy as freeFasFaCopy,
  faEllipsisVertical as freeFasFaEllipsisVertical,
  faBellSlash as freeFasFaBellSlash,
  faCalendarPlus as freeFasFaCalendarPlus,
  faSyncAlt as freeFasFaSyncAlt,
  faBug as freeFasFaBug,
  faDownload as freeFasFaDownload,
  faForward as freeFasFaForward,
  faLayerGroup as freeFasFaLayerGroup,
  faFileCode as freeFasFaFileCode,
  faSliders as freeFasFaSliders,
  faFolder as freeFasFaFolder,
  faPencil as freeFasFaPencil,
  faClipboardQuestion as freeFasFaClipboardQuestion,
  faCalendarAlt as freeFasFaCalendarAlt,
  faList as freeFasFaList,
  faFileExport as freeFasFaFileExport,
  faExternalLink as freeFasFaExternalLink,
  faLinkSlash as freeFasFaLinkSlash,
  faLink as freeFasFaLink,
  faUniversity as freeFasFaUniversity,
  faLeaf as freeFasFaLeaf,
  faChess as freeFasFaChess,
  faGlobe as freeFasFaGlobe,
  faMapLocationDot as freeFasFaMapLocationDot,
  faMapMarkerAlt as freeFasFaMapMarkerAlt,
  faIndustry as freeFasFaIndustry,
  faPenToSquare as freeFasFaPenToSquare,
  faHandPointer as freeFasFaHandPointer,
  faLightbulb as freeFasFaLightbulb,
  faFlask as freeFasFaFlask,
  faStopwatch as freeFasFaStopwatch,
  faImage as freeFasFaImage,
  faWifi as freeFasFaWifi,
  faCircle as freeFasFaCircle,
  faChevronUp as freeFasFaChevronUp,
  faFileLines as freeFasFaFileLines,
  faArrowRight as freeFasFaArrowRight,
  faArrowUpRightFromSquare as freeFasFaArrowUpRightFromSquare,
  faLandmark as freeFasFaLandmark,
  faBook as freeFasFaBook,
  faFilePdf as freeFasFaFilePdf,
  faQuoteLeft as freeFasFaQuoteLeft,
  faQuoteRight as freeFasFaQuoteRight,
  faUsers as freeFasFaUsers,
  faAnglesLeft as freeFasFaAnglesLeft,
  faAnglesRight as freeFasFaAnglesRight,
  faChartArea as freeFasFaChartArea,
  faKey as freeFasFaKey,
  faCode as freeFasFaCode,
  faUndo as freeFasFaUndo,
  faCog as freeFasFaCog,
  faHistory as freeFasFaHistory,
  faRetweet as freeFasFaRetweet,
  faQuestionCircle as freeFasFaQuestionCircle,
  faEnvelope as freeFasFaEnvelope,
  faClipboardCheck as freeFasFaClipboardCheck,
  faCloudUploadAlt as freeFasFaCloudUploadAlt,
  faCrown as freeFasFaCrown,
  faEllipsisH as freeFasFaEllipsisH,
  faEye as freeFasFaEye,
  faFilePen as freeFasFaFilePen,
  faFingerprint as freeFasFaFingerprint,
  faHourglassHalf as freeFasFaHourglassHalf,
  faInbox as freeFasFaInbox,
  faMinusCircle as freeFasFaMinusCircle,
  faPauseCircle as freeFasFaPauseCircle,
  faPen as freeFasFaPen,
  faRedo as freeFasFaRedo,
  faRepeat as freeFasFaRepeat,
  faShieldHalved as freeFasFaShieldHalved,
  faSync as freeFasFaSync,
  faTable as freeFasFaTable,
  faTimesCircle as freeFasFaTimesCircle,
  faUser as freeFasFaUser,
  faUserGear as freeFasFaUserGear,
  faUserShield as freeFasFaUserShield,
  faMicrochip as freeFasFaMicrochip,
  faCalendarDay as freeFasFaCalendarDay,
  faPhone as freeFasFaPhone,
  faCoins as freeFasFaCoins,
  faPenFancy as freeFasFaPenFancy,
  faBalanceScale as freeFasFaBalanceScale,
  faScaleBalanced as freeFasFaScaleBalanced,
  faEyeSlash as freeFasFaEyeSlash,
  faBan as freeFasFaBan,
  faUserSecret as freeFasFaUserSecret,
  faArrowRightFromBracket as freeFasFaArrowRightFromBracket,
  faGaugeHigh as freeFasFaGaugeHigh,
  faRobot as freeFasFaRobot,
  faArrowPointer as freeFasFaArrowPointer,
  faUnlockAlt as freeFasFaUnlockAlt,
  faSitemap as freeFasFaSitemap,
  faFileCircleXmark as freeFasFaFileCircleXmark,
  faArrowsRotate as freeFasFaArrowsRotate,
  faBookOpen as freeFasFaBookOpen,
  faCircleInfo as freeFasFaCircleInfo,
  faCircleQuestion as freeFasFaCircleQuestion,
  faCrosshairs as freeFasFaCrosshairs,
  faFilter as freeFasFaFilter,
  faServer as freeFasFaServer,
  faRss as freeFasFaRss,
  faCheckDouble as freeFasFaCheckDouble,
  faChartBar as freeFasFaChartBar,
  faCheckToSlot as freeFasFaCheckToSlot,
  faChartPie as freeFasFaChartPie,
  faFileExcel as freeFasFaFileExcel,
  faFileCsv as freeFasFaFileCsv,
  faMicroscope as freeFasFaMicroscope,
  faXmark as freeFasFaXmark,
  faCircleExclamation as freeFasFaCircleExclamation,
  faFileWord as freeFasFaFileWord,
  faCalculator as freeFasFaCalculator,
  faWandMagicSparkles as freeFasFaWandMagicSparkles,
  faHeart as freeFasFaHeart,
  faBoxArchive as freeFasFaBoxArchive,
  faSatelliteDish as freeFasFaSatelliteDish,
  faArchive as freeFasFaArchive,
  faArrowRotateLeft as freeFasFaArrowRotateLeft,
  faArrowsUpDownLeftRight as freeFasFaArrowsUpDownLeftRight,
  faBroom as freeFasFaBroom,
  faCalendarXmark as freeFasFaCalendarXmark,
  faCaretUp as freeFasFaCaretUp,
  faCircleCheck as freeFasFaCircleCheck,
  faCircleMinus as freeFasFaCircleMinus,
  faCirclePause as freeFasFaCirclePause,
  faCirclePlus as freeFasFaCirclePlus,
  faCircleXmark as freeFasFaCircleXmark,
  faCodeCompare as freeFasFaCodeCompare,
  faComments as freeFasFaComments,
  faCube as freeFasFaCube,
  faDollarSign as freeFasFaDollarSign,
  faEquals as freeFasFaEquals,
  faFileArchive as freeFasFaFileArchive,
  faFileContract as freeFasFaFileContract,
  faFlag as freeFasFaFlag,
  faFlagCheckered as freeFasFaFlagCheckered,
  faListOl as freeFasFaListOl,
  faMagnifyingGlass as freeFasFaMagnifyingGlass,
  faRotateRight as freeFasFaRotateRight,
  faShieldAlt as freeFasFaShieldAlt,
  faTableColumns as freeFasFaTableColumns,
  faTerminal as freeFasFaTerminal,
  faThumbtack as freeFasFaThumbtack,
  faTriangleExclamation as freeFasFaTriangleExclamation,
  faTrophy as freeFasFaTrophy,
  faUserPlus as freeFasFaUserPlus,
  faBackwardStep as freeFasFaBackwardStep,
  faForwardStep as freeFasFaForwardStep,
  faArrowTrendUp as freeFasFaArrowTrendUp,
  faArrowTrendDown as freeFasFaArrowTrendDown,
  faArrowsUpDown as freeFasFaArrowsUpDown,
  faArrowsLeftRight as freeFasFaArrowsLeftRight,
  faArrowUpRightDots as freeFasFaArrowUpRightDots,
  faDiagramProject as freeFasFaDiagramProject,
  faWaveSquare as freeFasFaWaveSquare,
  faEnvelopeOpenText as freeFasFaEnvelopeOpenText,
  faCommentDots as freeFasFaCommentDots,
  faHeartbeat as freeFasFaHeartbeat,
  faSlidersH as freeFasFaSlidersH,
  faPaperclip as freeFasFaPaperclip,
  faCloudArrowDown as freeFasFaCloudArrowDown,
  faCloudArrowUp as freeFasFaCloudArrowUp,
  faDiamond as freeFasFaDiamond,
  faFileCircleExclamation as freeFasFaFileCircleExclamation,
  faFileImage as freeFasFaFileImage,
  faFilePowerpoint as freeFasFaFilePowerpoint,
  faListUl as freeFasFaListUl,
  faPercent as freeFasFaPercent,
  faPlaneDeparture as freeFasFaPlaneDeparture,
  faTimeline as freeFasFaTimeline,
  faBuildingColumns as freeFasFaBuildingColumns,
  faVault as freeFasFaVault,
  faFileInvoice as freeFasFaFileInvoice,
  faDroplet as freeFasFaDroplet,
  faRightLeft as freeFasFaRightLeft,
  faGasPump as freeFasFaGasPump,
  faRoute as freeFasFaRoute,
  faLock as freeFasFaLock,
  faTableCells as freeFasFaTableCells,
  faBuildingFlag as freeFasFaBuildingFlag,
  faCodeMerge as freeFasFaCodeMerge,
  faTableList as freeFasFaTableList,
  faFolderPlus as freeFasFaFolderPlus,
  faSort as freeFasFaSort,
  faCaretDown as freeFasFaCaretDown,
  faCity as freeFasFaCity
} from '@fortawesome/free-solid-svg-icons'

import {
  faComment as freeFarFaComment,
  faCircle as freeFarFaCircle,
  faClock as freeFarFaClock,
  faHeart as freeFarFaHeart
} from '@fortawesome/free-regular-svg-icons'

import {
  faLinkedin as freeFabFaLinkedin,
  faTwitter as freeFabFaTwitter,
  faXTwitter as freeFabFaXTwitter,
  faGithub as freeFabFaGithub
} from '@fortawesome/free-brands-svg-icons'

export default {freeFasFaRightFromBracket, freeFasFaRightToBracket, freeFasFaGrip, freeFasFaSpinner, freeFasFaPlus, freeFasFaPaperPlane, freeFasFaExclamationTriangle, freeFasFaTimes, freeFasFaBell, freeFasFaBars, freeFasFaChevronRight, freeFasFaChevronLeft, freeFasFaClockRotateLeft, freeFasFaComment, freeFasFaChevronDown, freeFasFaMicrophone, freeFasFaCheck, freeFasFaTrash, freeFasFaVolumeUp, freeFasFaVolumeDown, freeFasFaVolumeMute, freeFasFaVolumeHigh, freeFasFaPlay, freeFasFaStop, freeFasFaPause, freeFasFaCheckCircle, freeFasFaBrain, freeFasFaFileAlt, freeFasFaArrowLeft, freeFasFaChartLine, freeFasFaSave, freeFasFaListCheck, freeFasFaBullseye, freeFasFaHome, freeFasFaTag, freeFasFaTags, freeFasFaInfoCircle, freeFasFaEdit, freeFasFaFileImport, freeFasFaRefresh, freeFasFaClipboardList, freeFasFaWrench, freeFasFaCogs, freeFasFaGear, freeFasFaCircleNotch, freeFasFaSearch, freeFasFaBuilding, freeFasFaBriefcase, freeFasFaTruck, freeFasFaCalendarCheck, freeFasFaExpand, freeFasFaClock, freeFasFaCalendar, freeFasFaUpload, freeFasFaDatabase, freeFasFaUserEdit, freeFasFaFile, freeFasFaExclamationCircle, freeFasFaMinus, freeFasFaExternalLinkAlt, freeFasFaRotate, freeFasFaNewspaper, freeFasFaFolderOpen, freeFasFaSun, freeFasFaMoon, freeFasFaBolt, freeFasFaArrowUp, freeFasFaArrowDown, freeFasFaHeartPulse, freeFasFaGripVertical, freeFasFaRotateLeft, freeFasFaThumbsUp, freeFasFaThumbsDown, freeFasFaCopy, freeFasFaEllipsisVertical, freeFasFaBellSlash, freeFasFaCalendarPlus, freeFasFaSyncAlt, freeFasFaBug, freeFasFaDownload, freeFasFaForward, freeFasFaLayerGroup, freeFasFaFileCode, freeFasFaSliders, freeFasFaFolder, freeFasFaPencil, freeFasFaClipboardQuestion, freeFasFaCalendarAlt, freeFasFaList, freeFasFaFileExport, freeFasFaExternalLink, freeFasFaLinkSlash, freeFasFaLink, freeFasFaUniversity, freeFasFaLeaf, freeFasFaChess, freeFasFaGlobe, freeFasFaMapLocationDot, freeFasFaMapMarkerAlt, freeFasFaIndustry, freeFasFaPenToSquare, freeFasFaHandPointer, freeFasFaLightbulb, freeFasFaFlask, freeFasFaStopwatch, freeFasFaImage, freeFasFaWifi, freeFasFaCircle, freeFasFaChevronUp, freeFasFaFileLines, freeFasFaArrowRight, freeFasFaArrowUpRightFromSquare, freeFasFaLandmark, freeFasFaBook, freeFasFaFilePdf, freeFasFaQuoteLeft, freeFasFaQuoteRight, freeFasFaUsers, freeFasFaAnglesLeft, freeFasFaAnglesRight, freeFasFaChartArea, freeFasFaKey, freeFasFaCode, freeFasFaUndo, freeFasFaCog, freeFasFaHistory, freeFasFaRetweet, freeFasFaQuestionCircle, freeFasFaEnvelope, freeFasFaClipboardCheck, freeFasFaCloudUploadAlt, freeFasFaCrown, freeFasFaEllipsisH, freeFasFaEye, freeFasFaFilePen, freeFasFaFingerprint, freeFasFaHourglassHalf, freeFasFaInbox, freeFasFaMinusCircle, freeFasFaPauseCircle, freeFasFaPen, freeFasFaRedo, freeFasFaRepeat, freeFasFaShieldHalved, freeFasFaSync, freeFasFaTable, freeFasFaTimesCircle, freeFasFaUser, freeFasFaUserGear, freeFasFaUserShield, freeFasFaMicrochip, freeFasFaCalendarDay, freeFasFaPhone, freeFasFaCoins, freeFasFaPenFancy, freeFasFaBalanceScale, freeFasFaScaleBalanced, freeFasFaEyeSlash, freeFasFaBan, freeFasFaUserSecret, freeFasFaArrowRightFromBracket, freeFasFaGaugeHigh, freeFasFaRobot, freeFasFaArrowPointer, freeFasFaUnlockAlt, freeFasFaSitemap, freeFasFaFileCircleXmark, freeFasFaArrowsRotate, freeFasFaBookOpen, freeFasFaCircleInfo, freeFasFaCircleQuestion, freeFasFaCrosshairs, freeFasFaFilter, freeFasFaServer, freeFasFaRss, freeFasFaCheckDouble, freeFasFaChartBar, freeFasFaCheckToSlot, freeFasFaChartPie, freeFasFaFileExcel, freeFasFaFileCsv, freeFasFaMicroscope, freeFasFaXmark, freeFasFaCircleExclamation, freeFasFaFileWord, freeFasFaCalculator, freeFasFaWandMagicSparkles, freeFasFaHeart, freeFasFaBoxArchive, freeFasFaSatelliteDish, freeFasFaArchive, freeFasFaArrowRotateLeft, freeFasFaArrowsUpDownLeftRight, freeFasFaBroom, freeFasFaCalendarXmark, freeFasFaCaretUp, freeFasFaCircleCheck, freeFasFaCircleMinus, freeFasFaCirclePause, freeFasFaCirclePlus, freeFasFaCircleXmark, freeFasFaCodeCompare, freeFasFaComments, freeFasFaCube, freeFasFaDollarSign, freeFasFaEquals, freeFasFaFileArchive, freeFasFaFileContract, freeFasFaFlag, freeFasFaFlagCheckered, freeFasFaListOl, freeFasFaMagnifyingGlass, freeFasFaRotateRight, freeFasFaShieldAlt, freeFasFaTableColumns, freeFasFaTerminal, freeFasFaThumbtack, freeFasFaTriangleExclamation, freeFasFaTrophy, freeFasFaUserPlus, freeFasFaBackwardStep, freeFasFaForwardStep, freeFasFaArrowTrendUp, freeFasFaArrowTrendDown, freeFasFaArrowsUpDown, freeFasFaArrowsLeftRight, freeFasFaArrowUpRightDots, freeFasFaDiagramProject, freeFasFaWaveSquare, freeFasFaEnvelopeOpenText, freeFasFaCommentDots, freeFasFaHeartbeat, freeFasFaSlidersH, freeFasFaPaperclip, freeFasFaCloudArrowDown, freeFasFaCloudArrowUp, freeFasFaDiamond, freeFasFaFileCircleExclamation, freeFasFaFileImage, freeFasFaFilePowerpoint, freeFasFaListUl, freeFasFaPercent, freeFasFaPlaneDeparture, freeFasFaTimeline, freeFasFaBuildingColumns, freeFasFaVault, freeFasFaFileInvoice, freeFasFaDroplet, freeFasFaRightLeft, freeFasFaGasPump, freeFasFaRoute, freeFasFaLock, freeFasFaTableCells, freeFasFaBuildingFlag, freeFasFaCodeMerge, freeFasFaTableList, freeFasFaFolderPlus, freeFasFaSort, freeFasFaCaretDown, freeFasFaCity, freeFarFaComment, freeFarFaCircle, freeFarFaClock, freeFarFaHeart, freeFabFaLinkedin, freeFabFaTwitter, freeFabFaXTwitter, freeFabFaGithub}